import { Link } from "react-router-dom";
import Room from "@/components/Room";

export default function WorkWith() {
  return (
    <Room title="Work / With" description="">
      <div className="fade">
        <div className="kicker">WORK / WITH</div>
        <h1 data-testid="work-with-h1">You have read enough to know whether this is for you.</h1>
        <div className="goldrule"></div>
        <p className="lede">For the length of the work, my attention belongs to one problem. Yours.</p>
      </div>

      <section className="q">
        <p>I look at what you hold from where biology and time meet it. What I find is usually already there, sitting in plain sight, unseen because no one was standing in that place to look.</p>
        <p>Each harvest, the fruit around the coffee bean and the nutmeg seed was thrown away, as it is almost everywhere in the world. That fruit is now a functional beverage ingredient, a second income drawn from what the land already produced. The same work raised the quality of the coffee, and the price it fetches. It is still running.</p>
        <p className="mid" data-testid="work-with-question">What leaves your land as waste each season?</p>
        <p>I hold no more than two engagements at a time and do the work myself. There is no team behind me, no junior handover and no template waiting to be filled.</p>
        <p>The work takes one of three forms. A conversation: one sitting, on one question you cannot resolve alone. A classification: a territory, portfolio or book read for what time will do to it. Counsel, held by the month: once I say yes, part of my mind stays with your problem and does not leave. That is what is being held, not hours, and it is why there are never more than two.</p>
        <p>It is not for anyone looking for a report to file, a framework to borrow, or a second opinion that confirms the first.</p>
        <Link className="why-link" to="/enter/work-with" data-testid="work-with-enter">Why does this matter?</Link>
        <p>Every answer receives a reply. If there is something to do together, you will hear from me. If there is not, you will hear that too.</p>
      </section>
    </Room>
  );
}
